import { UiSchema } from '@rjsf/utils'

import { FormProperties } from '../imup/types'

export const uiSchema: UiSchema = {
    'ui:order': ['item_number', 'sheathing'],
    sheathing: {
        'ui:placeholder': 'Select Decking Sheathing Type',
    },
}

const onValidate = () => {}

const onSubmit = (settings, formData) => {
    const newSettings = { ...settings, ...formData }

    return newSettings
}

const form: FormProperties = { uiSchema, onValidate, onSubmit }

export default form
